import { render, staticRenderFns } from "./gameCardConfig.vue?vue&type=template&id=9e8773a8&"
import script from "./gameCardConfig.vue?vue&type=script&lang=js&"
export * from "./gameCardConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e8773a8')) {
      api.createRecord('9e8773a8', component.options)
    } else {
      api.reload('9e8773a8', component.options)
    }
    module.hot.accept("./gameCardConfig.vue?vue&type=template&id=9e8773a8&", function () {
      api.rerender('9e8773a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameCardConfig.vue"
export default component.exports